var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeaf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.79281 3.37275C-0.368437 5.534 -0.368437 9.049 1.79281 11.2103C2.8774 12.2948 4.29448 12.8332 5.71156 12.8332C7.12865 12.8332 8.54573 12.2948 9.63031 11.2103C12.3853 8.45525 12.8366 0.166504 12.8366 0.166504C12.8366 0.166504 4.54781 0.617754 1.79281 3.37275ZM8.51406 10.094C7.76198 10.8382 6.7724 11.2498 5.71156 11.2498C5.00698 11.2498 4.34198 11.0519 3.74823 10.7115C4.47656 8.4315 5.8224 6.42859 7.61156 4.9165C5.52948 5.99317 3.7799 7.65567 2.56865 9.6665C1.39698 8.11484 1.4999 5.90609 2.91698 4.489C4.29448 3.1115 8.11823 2.26442 11.0949 1.90817C10.7386 4.88484 9.89156 8.70859 8.51406 10.094Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaf);
export default __webpack_public_path__ + "static/media/Leaf.4bde0d15e5fbbafc80934c531ed76ca4.svg";
export { ForwardRef as ReactComponent };